import type { BadgeProps } from '@/design-system/badge';
import type { PitstopQueueStatus } from '@/services/api/pitstopSchedules';

type BadgeStatus = NonNullable<BadgeProps['status']>;

/** Ops-facing labels for a queue occurrence's lifecycle (TRD v2 §D2). */
export const QUEUE_STATUS_LABELS: Record<PitstopQueueStatus, string> = {
  QUEUED: 'Queued',
  PREVIEWED: 'Previewed',
  COMMITTED: 'Committed',
  SKIPPED_EMPTY: 'Skipped (kosong)',
  FAILED: 'Failed',
};

export const QUEUE_STATUS_TONE: Record<PitstopQueueStatus, BadgeStatus> = {
  QUEUED: 'faded',
  PREVIEWED: 'information',
  COMMITTED: 'success',
  SKIPPED_EMPTY: 'neutral',
  FAILED: 'error',
};
